import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, SubmissionError } from "redux-form";
import {
  validate,
  checkIfEmpty,
  normalizePhone,
  stripPhoneFormatting,
} from "./validation/EditProfileForm";

import trimString from "../../../utils/trimString";

const allStates = [
  "AL",
  "AK",
  "AS",
  "AZ",
  "AR",
  "AA",
  "AE",
  "AP",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MH",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "MP",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VI",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

const renderField = ({
  input,
  type,
  placeholder,
  className,
  initialValues,
  meta: { error },
}) => {
  const errorToShow = error ? error[0] : null;
  return (
    <div>
      <input
        {...input}
        className={className}
        type={type}
        placeholder={placeholder}
      ></input>
      {errorToShow ? <div className="errorMsg">{errorToShow}</div> : null}
    </div>
  );
};

const renderDropdown = ({ input, className, meta: { error } }) => {
  const errorToShow = error ? error[0] : null;
  return (
    <div>
      <select {...input} className={className}>
        <option value="" disabled="disabled">
          State
        </option>
        {allStates.map((state, key) => (
          <option value={state} key={key}>
            {state}
          </option>
        ))}
      </select>
      {errorToShow ? <div className="errorMsg">{errorToShow}</div> : null}
    </div>
  );
};

const CustomerProfileForm = (props) => {
  const {
    handleSubmit,
    closeEditProfileModal,
    updateCustomerProfile,
    customerId,
  } = props;

  const submit = (fields) => {
    const response = checkIfEmpty(fields);

    if (Object.keys(response).length) {
      throw new SubmissionError(response);
    }

    fields.id = customerId;
    fields.phone = stripPhoneFormatting(trimString(fields.phone));
    fields.street = trimString(fields.street);
    fields.city = trimString(fields.city);
    fields.zip = trimString(fields.zip);
    updateCustomerProfile(fields);
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      <div className="modal-input-mar-b-20">
        <div className="modal-input-flex-2-pad-r-10">
          <Field
            name="street"
            component={renderField}
            type="text"
            placeholder="Address"
            className="cc-input"
          />
        </div>
        <div className="modal-input-pad-l-10">
          <Field
            name="street2"
            component={renderField}
            type="text"
            placeholder="Apt (optional)"
            className="cc-input"
          />
        </div>
      </div>
      <div className="modal-input-mar-b-20">
        <div className="modal-input-flex-1">
          <Field
            name="city"
            component={renderField}
            type="text"
            placeholder="City"
            className="cc-input"
          />
        </div>
      </div>
      <div className="modal-input-mar-b-20">
        <div className="modal-input-pad-r-10">
          <Field name="state" component={renderDropdown} className="cc-input" />
        </div>
        <div className="modal-input-pad-both-10">
          <Field
            name="zip"
            component={renderField}
            type="text"
            placeholder="Zip Code"
            className="cc-input"
          />
        </div>
        <div className="modal-input-pad-l-10">
          <Field
            name="phone"
            component={renderField}
            normalize={normalizePhone}
            type="text"
            placeholder="Phone"
            className="cc-input"
          />
        </div>
      </div>
      <div className="modal-input-mar-b-20">
        <div className="modal-input-flex-2-pad-r-10">
          <button type="submit" className="acct-pg-btn acct-pg-btn-block">
            Save & Continue
          </button>
        </div>
        <div className="modal-input-pad-l-10">
          <div
            className="acct-pg-btn-inverse acct-pg-btn-block"
            onClick={closeEditProfileModal}
          >
            Close
          </div>
        </div>
      </div>
    </form>
  );
};

export default connect((state) => ({
  initialValues: {
    street: state.customer.address[0].street,
    street2: state.customer.address[0].street2,
    city: state.customer.address[0].city,
    state: state.customer.address[0].state,
    zip: state.customer.address[0].postcode,
    phone: normalizePhone(state.customer.phone[0].number.toString()),
  },
}))(
  reduxForm({
    form: "profile",
    validate,
    enableReinitialize: true,
  })(CustomerProfileForm)
);
